
import {
  Component, Watch, PropSync, Ref, Mixins,
} from 'vue-property-decorator';
import { getWeekdaysFromToday, DayType } from '@/features/common/helpers/moment';
import { pickUpLocations, earliestPickupTimes, latestPickupTimes } from '@/features/common/raw';
import Tooltip from '@/features/common/components/Tooltip.vue';
import { UserPreferences } from '@/features/settings/types';
import { useConvertTime } from '@/features/common/helpers';
import { ScheduleDataType } from '@/features/schedule-pickup/types';
import { VForm } from '@/features/common/types';
import { requiredRules } from '@/features/common/helpers/validationRules';
import { stripUnoChars } from '@/features/common/helpers/strUtils';
import focusMixin from '@/features/common/mixins/focusMixin';

@Component({
  components: {
    Tooltip,
  },
})
export default class PickupSpecificsModal extends Mixins(focusMixin) {
  @Ref('pickupSpecificsForm') form!: VForm;

  @PropSync('show', { required: true }) syncedShow!: boolean;

  @PropSync('scheduleData', { required: true }) syncScheduleData!: ScheduleDataType;

  private pickupLocations = pickUpLocations;

  private pickupDates: DayType[] = [];

  private earliestPickupTimes = earliestPickupTimes;

  private latestPickupTimes = latestPickupTimes;

  get isUserPreferences(): number {
    return this.$store.getters.getIsUserPreferences;
  }

  get userPreferences(): UserPreferences {
    return this.$store.getters.getUserPreferences;
  }

  private requiredRules = requiredRules;

  @Watch('isUserPreferences', { immediate: true })
  private populateDataFromPreferences(newValue: number | boolean) {
    if (!newValue) return;

    const { schedulePickup } = this.userPreferences;

    this.syncScheduleData.earliestTime = useConvertTime(
      schedulePickup.readyTime, earliestPickupTimes[0],
    ) || earliestPickupTimes[0];

    this.syncScheduleData.latestTime = useConvertTime(schedulePickup.closeTime)
          || this.latestPickupTimes[10];

    this.syncScheduleData.pickupLocation = stripUnoChars(schedulePickup.location as string)
          || this.pickupLocations[0].value;

    this.syncScheduleData.comments = schedulePickup.comments || '';
  }

  created(): void {
    this.pickupDates = getWeekdaysFromToday();
    [this.syncScheduleData.pickupDate] = this.pickupDates;
  }

  private goToSchedulePickup(): void {
    const isValid = this.form.validate();
    if (!isValid) return;

    this.syncedShow = false;
    this.$emit('next');
  }
}
